// extracted by mini-css-extract-plugin
var _1 = "styles-module__splitLabel___xrTaf";
var _2 = "styles-module__splitLabels___vblMY";
var _3 = "styles-module__splits___yOhDv";
var _4 = "styles-module__splitsContainer___p84xa";
var _5 = "styles-module__title___UlsuA";
export { _1 as "splitLabel", _2 as "splitLabels", _3 as "splits", _4 as "splitsContainer", _5 as "title" }
